let arr=[
    {name:'未启用',value:'未启用'},
    {name:'启用',value:'启用'},
    {name:'停用',value:'停用'}
]
export default arr